import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWarehouseList } from "src/api/bi";

export const fetchWarehouseList = createAsyncThunk(
  "warehouse/fetchWarehouseList",
  async () => {
    const response = await getWarehouseList();
    return response.data;
  }
);

// Create slice for warehouse state
const warehouseSlice = createSlice({
  name: "warehouse",
  initialState: {
    warehouseList: [],
    status: "idle",
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWarehouseList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWarehouseList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.warehouseList = action.payload.map(
          (item: { warehouseNo: string; warehouseName: string }) => ({
            id: item.warehouseNo.toString().padStart(4, "0"),
            name: item.warehouseName
          })
        );
      })
      .addCase(fetchWarehouseList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  }
});

export default warehouseSlice.reducer;

// Selectors
export const selectWarehouseListStatus = (state: any) => state.warehouse.status;
export const selectWarehouseListError = (state: any) => state.warehouse.error;
export const selectWarehouseList = (state: any) =>
  state.warehouse.warehouseList;
